module.exports = __webpack_public_path__ + "img/resetpassword3.a80d7ef.png";